export default __webpack_public_path__ + "assets/hero_1280.52b72b50.webp";